import React from 'react'
import {useForm} from "react-hook-form";

const GenerateServiceName = ({ nextStep, handleChange, values }) => {

    const {
        register,
        formState: { errors }
    } = useForm();

    const Continue = e => {
        e.preventDefault();
        nextStep();
    }
    const styles = {
        container: {
            width: "80%",
            margin: "0 auto",
        },
        input: {
            width: "100%",
        },
    };

    return (
        <div className="row">
            <div className="col-md-12">
            <h5 className="tbsub-title mt-3 mb-3">Step 2 of 4</h5>
                <form>
                    <div className="col-md-12">
                        <div className="form-group row">
                            <label className="control-label col-md-4"> Enter Service Name:</label>
                            <input type="text" {...register("email", { required: true, maxLength: 200 })}
                                   style={{ ...styles.input, borderColor: errors.email && "red",marginRight:"50px" }} onChange={handleChange('email')}
                                   className="form-control form-control-sm col-md-3" />
                        </div>
                    </div>
                    <button onClick={ Continue }
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            className="btn btn-primary"
                    >Next</button>
                </form>
            </div>
        </div>
    )
}

export default GenerateServiceName